import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRACKERMILESTONE_LOAD,
    ACTION_TRACKERMILESTONE_LOAD_BY_ID,

    ACTION_TRACKERMILESTONE_SAVE,

    ACTION_TRACKERMILESTONE_CREATE,

    ACTION_TRACKERMILESTONE_VALIDATE,

    ITrackerMilestoneLoadAction,
    ITrackerMilestoneLoadByIdAction,
    ITrackerMilestoneLoadFailureAction,
    ITrackerMilestoneLoadSuccessAction,

    ITrackerMilestoneSaveAction,
    ITrackerMilestoneSaveSuccessAction,
    ITrackerMilestoneSaveFailureAction,

    ITrackerMilestoneCreateAction,
    ITrackerMilestoneCreateSuccessAction,
    ITrackerMilestoneCreateFailureAction,

    ITrackerMilestoneValidateAction,
    ITrackerMilestoneValidateSuccessAction,
    ITrackerMilestoneValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trackerMilestones";
import { trackerMilestoneApi } from "../services/trackerMilestone";

export const
    getTrackerMilestonesEpic = (action$): Observable<ITrackerMilestoneLoadSuccessAction | ITrackerMilestoneLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERMILESTONE_LOAD)
            .mergeMap((_action: ITrackerMilestoneLoadAction) => {
                return trackerMilestoneApi
                    .getTrackerMilestones()
                    .map(response =>
                        LoadSuccess(response.trackerMilestones, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrackerMilestoneByIdEpic = (action$): Observable<ITrackerMilestoneLoadSuccessAction | ITrackerMilestoneLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERMILESTONE_LOAD_BY_ID)
            .mergeMap((action: ITrackerMilestoneLoadByIdAction) => {
                return trackerMilestoneApi
                    .getTrackerMilestoneById(action.id)
                    .map(response =>
                        LoadSuccess(response.trackerMilestone, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrackerMilestoneEpic = (action$): Observable<ITrackerMilestoneSaveSuccessAction | ITrackerMilestoneSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERMILESTONE_SAVE)
            .mergeMap((action: ITrackerMilestoneSaveAction) => {
                return trackerMilestoneApi
                    .setTrackerMilestone(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trackerMilestone, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrackerMilestoneEpic = (action$): Observable<ITrackerMilestoneCreateSuccessAction | ITrackerMilestoneCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERMILESTONE_CREATE)
            .mergeMap((_action: ITrackerMilestoneCreateAction) => {
                return trackerMilestoneApi
                    .createTrackerMilestone()
                    .map(response =>
                        CreateSuccess(
                            response.trackerMilestone,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrackerMilestoneEpic = (action$): Observable<ITrackerMilestoneValidateSuccessAction | ITrackerMilestoneValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERMILESTONE_VALIDATE)
            .mergeMap((action: ITrackerMilestoneValidateAction) => {
                return trackerMilestoneApi
                    .validateTrackerMilestone(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trackerMilestone, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }